const ADDRESS = "address";
const NAME = "name";
const STATUS = "status";
const PLIESNUMBER = 'pliesNumber'; 
const STRUCTURETYPE = 'structureType';
const BUILDAREA = 'buildArea';
const DANGERREMOULD = 'dangerRemould';
const DanGERREMOULDLEVEL = 'dangerRemouldLevel';
const DanGERREMOULDYEAR = 'dangerRemouldYear';
const SAFETYASSESSRESULT = 'safetyAssessResult';
const HOUSETYPE = 'houseType';

export default {
    getAddress() {
        if (localStorage.getItem(ADDRESS) === null || localStorage.getItem(ADDRESS) === 'null' || localStorage.getItem(ADDRESS) === "") {
            return [];
        }
        return JSON.parse(localStorage.getItem(ADDRESS));
    },
    setAddress(address) {
        localStorage.setItem(ADDRESS, JSON.stringify(address));
    },
    getName(){
        if (localStorage.getItem(NAME) === null || localStorage.getItem(NAME) === 'null' || localStorage.getItem(NAME) === "") {
            return "";
        }
        return localStorage.getItem(NAME);
    },
    setName(name) {
        localStorage.setItem(NAME, name);
    },
    getStatus() {
        if (localStorage.getItem(STATUS) === null || localStorage.getItem(STATUS) === 'null' || localStorage.getItem(STATUS) === "") {
            return "";
        }
        return localStorage.getItem(STATUS);
    },
    setStatus(status){
        localStorage.setItem(STATUS, status);
    },

    getPliesNumber() {
        if (localStorage.getItem(PLIESNUMBER) === null || localStorage.getItem(PLIESNUMBER) === 'null' || localStorage.getItem(PLIESNUMBER) === "") {
            return [];
        }
        return localStorage.getItem(PLIESNUMBER);
    },
    setPliesNumber(pliesNumber) {
        localStorage.setItem(PLIESNUMBER, pliesNumber);
    },
    getStructureType(){
        if (localStorage.getItem(STRUCTURETYPE) === null || localStorage.getItem(STRUCTURETYPE) === 'null' || localStorage.getItem(STRUCTURETYPE) === "") {
            return "";
        }
        return localStorage.getItem(STRUCTURETYPE);
    },
    setStructureType(structureType) {
        localStorage.setItem(STRUCTURETYPE, structureType);
    },
    getBuildArea() {
        if (localStorage.getItem(BUILDAREA) === null || localStorage.getItem(BUILDAREA) === 'null' || localStorage.getItem(BUILDAREA) === "") {
            return "";
        }
        return localStorage.getItem(BUILDAREA);
    },
    setBuildArea(buildArea){
        localStorage.setItem(BUILDAREA, buildArea);
    },
    getDangerRemould() {
        if (localStorage.getItem(DANGERREMOULD) === null || localStorage.getItem(DANGERREMOULD) === 'null' || localStorage.getItem(DANGERREMOULD) === "") {
            return [];
        }
        return localStorage.getItem(DANGERREMOULD);
    },
    setDangerRemould(dangerRemould) {
        localStorage.setItem(DANGERREMOULD, JSON.stringify(dangerRemould));
    },
    getDangerRemouldLevel(){
        if (localStorage.getItem(DanGERREMOULDLEVEL) === null || localStorage.getItem(DanGERREMOULDLEVEL) === 'null' || localStorage.getItem(DanGERREMOULDLEVEL) === "") {
            return "";
        }
        return localStorage.getItem(DanGERREMOULDLEVEL);
    },
    setDangerRemouldLevel(dangerRemouldLevel) {
        localStorage.setItem(DanGERREMOULDLEVEL, dangerRemouldLevel);
    },
    getDangerRemouldYear() {
        if (localStorage.getItem(DanGERREMOULDYEAR) === null || localStorage.getItem(DanGERREMOULDYEAR) === 'null' || localStorage.getItem(DanGERREMOULDYEAR) === "") {
            return "";
        }
        return localStorage.getItem(DanGERREMOULDYEAR);
    },
    setDangerRemouldYear(dangerRemouldYear){
        localStorage.setItem(DanGERREMOULDYEAR, dangerRemouldYear);
    },
    getSafetyAssessResult(){
        if (localStorage.getItem(SAFETYASSESSRESULT) === null || localStorage.getItem(SAFETYASSESSRESULT) === 'null' || localStorage.getItem(SAFETYASSESSRESULT) === "") {
            return "";
        }
        return localStorage.getItem(SAFETYASSESSRESULT);
    },
    setSafetyAssessResult(safetyAssessResult) {
        localStorage.setItem(SAFETYASSESSRESULT, safetyAssessResult);
    },
    getHouseType() {
        if (localStorage.getItem(HOUSETYPE) === null || localStorage.getItem(HOUSETYPE) === 'null' || localStorage.getItem(HOUSETYPE) === "") {
            return "";
        }
        return localStorage.getItem(HOUSETYPE);
    },
    setHouseType(houseType){
        localStorage.setItem(HOUSETYPE, houseType);
    },
};
